module.exports = __webpack_public_path__ + "static/media/business-people-min.608404e7.jpg";